import Vue from 'vue'
import Router from 'vue-router'
import HelloWorld from '@/components/HelloWorld'
import Home from '@/components/home/home'
import Test from '@/components/test'
import QuickOrders from '@/components/order/quickOrders'
import ClientOrders from '@/components/order/clientOrders2'
import QuickOrdersQuery from '@/components/order/quickOrdersQuery'
import ClientOrdersQuery  from '@/components/order/clientOrdersQuery'
import PlaceOrders  from '@/components/order/placeOrders'
import Login from '@/components/pages/login'
import Introduction from '@/components/pages/Introduction'
import Contact from '@/components/pages/Contact'
import Map from '@/components/pages/Map'
import Members from '@/components/pages/Members'
import BillIssue from "../components/order/billIssue";
import PurInQuery from "../components/pages/PurInQuery";
import PurFlowQuery from "../components/pages/PurFlowQuery";
import SaleOutQuery from "../components/pages/SaleOutQuery";
import SaleFlowQuery from "../components/pages/SaleFlowQuery";
import PlatformBalanceQuery from "../components/pages/PlatformBalanceQuery";
import MyBalanceQuery from "../components/pages/MyBalanceQuery";
import WmsBluntQuery from "../components/pages/WmsBluntQuery";
import SaleOut from "../components/pages/SaleOut";
import ClientSaleFlowQuery from "../components/pages/ClientSaleFlowQuery";
import ClientSaleNotesQuery from "../components/pages/ClientSaleNotesQuery";
Vue.use(Router)

// 解决Vue-Router升级导致的Uncaught(in promise) navigation guard问题
const originalPush = Router.prototype.push;
Router.prototype.push = function push(location, onResolve, onReject) {
  if (onResolve || onReject)
    return originalPush.call(this, location, onResolve, onReject);
  return originalPush.call(this, location).catch((err) => err);
};


export default new Router({
  mode:'hash',
  routes: [

    {
      path: '/login',
      name: 'Login',
      component: Login
    },
    {
      path: '/',
      name: 'Home',
      component: Home
    },
    {
      path: '/map',
      name: 'Map',
      component: Map
    },
    {
      path: '/introduction',
      name: 'Introduction',
      component: Introduction

    },
    {
      path: '/home',
      name: 'Home',
      component: Home
    },

    {
      path: '/contact',
      name: 'Contact',
      component: Contact
    },
    {
      path: '/hellWorld',
      name: 'HelloWorld',
      meta: {
        requireAuth: true, // 判断是否需要登录
      },
      component: HelloWorld
    },
    {
      path: '/quickOrders',
      name: 'QuickOrders',
      meta: {
        requireAuth: true, // 判断是否需要登录
      },
      component: QuickOrders
    },
    {
      path: '/test',
      name: 'Test',
      meta: {
        requireAuth: true, // 判断是否需要登录
      },
      component: Test
    },
    {
      path: '/clientOrders',
      name: 'ClientOrders',
      meta: {
        requireAuth: true, // 判断是否需要登录
      },
      component: ClientOrders
    },
    {
      path: '/quickOrdersQuery',
      name: 'QuickOrdersQuery',
      meta: {
        requireAuth: true, // 判断是否需要登录
      },
      component: QuickOrdersQuery
    },
    {
      path: '/clientOrdersQuery',
      name: 'ClientOrdersQuery',
      meta: {
        requireAuth: true, // 判断是否需要登录
      },
      component: ClientOrdersQuery
    },
    {
      path: '/placeOrders',
      name: 'PlaceOrders',
      meta: {
        requireAuth: true, // 判断是否需要登录
      },
      component: PlaceOrders
    },
    {
      path: '/members',
      name: 'Members',
      meta: {
        requireAuth: true, // 判断是否需要登录
      },
      component: Members
    },
    {
      path: '/members',
      name: 'Members',
      meta: {
        requireAuth: true, // 判断是否需要登录
      },
      component: Members
    }
    ,

    // {
    //   "name":"出库查询",
    //   "url":"/saleOutQuery"
    // },
    // {
    //   "name":"入库查询",
    //   "url":"/purInQuery"
    // },
    // {
    //   "name":"销售流向查询",
    //   "url":"/saleFlowQuery"
    // },
    // {
    //   "name":"采购流向查询",
    //   "url":"/purFlowQuery"
    // },

    {
      path: '/saleOutQuery',
      name: 'SaleOutQuery',
      meta: {
        requireAuth: true, // 判断是否需要登录
      },
      component: SaleOutQuery
    }
    ,
    {
      path: '/purInQuery',
      name: 'PurInQuery',
      meta: {
        requireAuth: true, // 判断是否需要登录
      },
      component: PurInQuery
    }
    ,
    {
      path: '/saleFlowQuery',
      name: 'SaleFlowQuery',
      meta: {
        requireAuth: true, // 判断是否需要登录
      },
      component: SaleFlowQuery
    }
    ,
    {
      path: '/purFlowQuery',
      name: 'PurFlowQuery',
      meta: {
        requireAuth: true, // 判断是否需要登录
      },
      component: PurFlowQuery
    },
    {
      path: '/platformBalanceQuery',
      name: 'PlatformBalanceQuery',
      meta: {
        requireAuth: true, // 判断是否需要登录
      },
      component: PlatformBalanceQuery
    },
    {
      path: '/myBalanceQuery',
      name: 'MyBalanceQuery',
      meta: {
        requireAuth: true, // 判断是否需要登录
      },
      component: MyBalanceQuery
    },
    {
      path: '/wmsBluntQuery',
      name: 'WmsBluntQuery',
      meta: {
        requireAuth: true, // 判断是否需要登录
      },
      component: WmsBluntQuery
    },
    {
      path: '/saleOut',
      name: 'SaleOut',
      meta: {
        requireAuth: true, // 判断是否需要登录
      },
      component: SaleOut
    },
    {
      path: '/clientSaleFlowQuery',
      name: 'ClientSaleFlowQuery',
      meta: {
        requireAuth: true, // 判断是否需要登录
      },
      component: ClientSaleFlowQuery
    },
    {
      path: '/clientSaleNotesQuery',
      name: 'ClientSaleNotesQuery',
      meta: {
        requireAuth: true, // 判断是否需要登录
      },
      component: ClientSaleNotesQuery
    },


  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js